<div class="form-group" *ngIf="pollinationCategory && pollinationCategory.value">
  <span class="col-sm-2 control-label">Stake Label: </span>
  <span class="col-sm-10 form-control-static" style="white-space: pre-line;">{{ stakeLabel }}</span>
</div>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/pollination-instructions/pollination-stake-label/pollination-stake-label.component.html